import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { AppState } from '.';
import { CouponInfo, SerializedException, exceptionOf } from '../models';
import * as CouponService from '../services/coupon';

export const COUPON_FEATURE_KEY = 'coupon';

interface CouponState {
  coupon: CouponInfo | null;
  loading: boolean;
  errors: SerializedException[];
}

const createInitialState = (): CouponState => ({
  coupon: null,
  loading: false,
  errors: [],
});

export const doFetchCouponByCode = createAsyncThunk(
  'coupon/fetchCouponByCode',
  async (code: string, { rejectWithValue }) => {
    try {
      return await CouponService.getCouponByCode(code);
    } catch (e: any) {
      return rejectWithValue(exceptionOf(e).toJson());
    }
  },
);

const couponSlice = createSlice({
  name: COUPON_FEATURE_KEY,
  initialState: createInitialState(),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(doFetchCouponByCode.pending, state => {
        state.loading = true;
        state.errors = [];
      })
      .addCase(
        doFetchCouponByCode.fulfilled,
        (state, action: PayloadAction<CouponInfo | null>) => {
          state.loading = false;
          state.coupon = action.payload;
        },
      )
      .addCase(doFetchCouponByCode.rejected, (state, action) => {
        state.loading = false;
        state.coupon = null;
        state.errors = [action.payload as SerializedException];
      });
  },
});

// Selectors
const selectCouponState = (state: AppState) => state[COUPON_FEATURE_KEY];

export const selectCoupon = (state: AppState) => selectCouponState(state).coupon;

// Reducer
export default couponSlice.reducer;
